import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { WorkingHours } from '@shared/models';

import { BaseService } from '../base.service';
import { httpParams } from '../http-params.builder';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class WorkingHoursService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  get(loader: string, projectId?: string, weeks?: string[]): Observable<WorkingHours[]> {
    this.loadersService.show(loader);
    const url = `${this.baseUrl}/working-hours` + (projectId ? `/project/${projectId}` : '');
    return this.http
      .get<WorkingHours[]>(url, { params: httpParams().array('weeks', weeks).build() })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  edit(loader: string, workingHours: WorkingHours[], projectId?: string, weeks?: string[]): Observable<WorkingHours[]> {
    this.loadersService.show(loader);
    return this.http
      .put<
        WorkingHours[]
      >(`${this.baseUrl}/working-hours`, { workingHours: workingHours, projectId: projectId }, { params: httpParams().array('weeks', weeks).build() })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
